var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Icon, Text, Box } from '@gympass/yoga';
import { ChevronLeft, ChevronRight } from '@gympass/yoga-icons';
import { oneOf, func, instanceOf, bool } from 'prop-types';
import _ from 'lodash';
var CalendarWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var spacing = _ref.theme.yoga.spacing;
  return "\n    padding: " + spacing.xsmall + "px " + spacing.xsmall + "px " + spacing.small + "px " + spacing.xsmall + "px;\n  ";
});
var DaysWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var spacing = _ref2.theme.yoga.spacing;
  return "\n    display: flex;\n    justify-content: space-between;\n    margin: " + spacing.xxsmall + "px " + spacing.zero + "px " + spacing.xsmall + "px " + spacing.zero + "px;\n  ";
});
var Day = styled(Text.SectionTitle)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref3) {
  var colors = _ref3.theme.yoga.colors;
  return "\n    width: 40px;\n    color: " + colors.medium + ";\n    text-align: center;\n  ";
});

var getDayFieldColor = function getDayFieldColor(selected, disabled, colors, aux) {
  if (selected && !disabled) {
    return colors.white;
  }

  if (disabled) {
    return colors.text.disabled;
  }

  var currentDate = new Date();
  var val = aux.val,
      year = aux.year,
      month = aux.month;

  if ( // if current date
  new Date(Date.UTC(year, month, val)).getTime() === new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())).getTime()) {
    return colors.primary;
  }

  return colors.stamina;
};

var toUTCDate = function toUTCDate(date) {
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())).getTime();
};

var getDayFieldRadius = function getDayFieldRadius(aux, radii) {
  var _Date;

  var val = aux.val,
      startDate = aux.startDate,
      endDate = aux.endDate,
      year = aux.year,
      month = aux.month;
  var currentDate = (_Date = new Date(Date.UTC(year, month, val))) == null ? void 0 : _Date.getTime();

  if (currentDate === toUTCDate(startDate) && endDate) {
    return radii.circle + "px " + radii.sharp + "px " + radii.sharp + "px " + radii.circle + "px";
  }

  if (currentDate === toUTCDate(endDate) && startDate) {
    return radii.sharp + "px " + radii.circle + "px " + radii.circle + "px " + radii.sharp + "px";
  }

  return radii.sharp + "px";
};

var DayField = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref4) {
  var selected = _ref4.selected,
      inRange = _ref4.inRange,
      disabled = _ref4.disabled,
      aux = _ref4.aux,
      _ref4$theme$yoga = _ref4.theme.yoga,
      colors = _ref4$theme$yoga.colors,
      radii = _ref4$theme$yoga.radii,
      spacing = _ref4$theme$yoga.spacing,
      datepicker = _ref4$theme$yoga.components.datepicker;
  return "\n    p {\n        color: " + getDayFieldColor(selected, disabled, colors, aux) + ";\n        z-index: 1;\n    }\n    width: " + datepicker.width.day + "px;\n    height: " + datepicker.width.day + "px;\n    padding: " + spacing.zero + "px 21.3px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: " + (inRange ? colors.clear : colors.white) + ";\n    position: relative;\n    cursor: pointer;\n    " + (selected && inRange ? "border-radius: " + getDayFieldRadius(aux, radii) : "") + "\n    " + (selected && !disabled ? "&:before {\n            content: '';\n            position: absolute;\n            background: " + colors.vibin + ";\n            width: " + datepicker.width.day + "px;\n            height: " + datepicker.width.day + "px;\n            border-radius: " + radii.circle + "px;\n        }" : "") + "\n    " + (!disabled ? "&:hover {\n            &:before {\n              content: '';\n              position: absolute;\n              border: 1px solid " + colors.secondary + ";\n              width: " + datepicker.width.day + "px;\n              height: " + datepicker.width.day + "px;\n              border-radius: " + radii.circle + "px;\n            }\n          }" : "") + "\n";
});
var Row = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref5) {
  var _ref5$theme$yoga = _ref5.theme.yoga,
      radii = _ref5$theme$yoga.radii,
      spacing = _ref5$theme$yoga.spacing;
  return "\n    display: flex;\n    div:first-child {\n        border-radius: " + radii.regular + "px 0 0 " + radii.regular + "px;\n    }\n    div:last-child {\n        border-radius: 0 " + radii.regular + "px " + radii.regular + "px 0;\n    }\n    padding: " + spacing.xxxsmall + "px 0px;\n";
});

function Calendar(_ref6) {
  var type = _ref6.type,
      startDate = _ref6.startDate,
      endDate = _ref6.endDate,
      onSelectSingle = _ref6.onSelectSingle,
      onSelectRange = _ref6.onSelectRange,
      disablePastDates = _ref6.disablePastDates,
      disableFutureDates = _ref6.disableFutureDates;

  var _useState = useState(new Date().getUTCMonth()),
      month = _useState[0],
      setMonth = _useState[1];

  var _useState2 = useState(new Date().getUTCFullYear()),
      year = _useState2[0],
      setYear = _useState2[1];

  useEffect(function () {
    if (startDate) {
      setMonth(startDate.getUTCMonth());
      setYear(startDate.getUTCFullYear());
    }
  }, [startDate]);

  var getDayOfWeek = function getDayOfWeek(day) {
    return new Date(Date.UTC(year, month, day)).getUTCDay();
  };

  var getDaysInMonth = function getDaysInMonth() {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  };

  var getDaysInMonthBefore = function getDaysInMonthBefore() {
    return new Date(Date.UTC(year, month, 0)).getUTCDate();
  };

  var toUTCDateDay = function toUTCDateDay(day) {
    return new Date(Date.UTC(year, month, day)).getTime();
  };

  var isEqual = function isEqual(day) {
    return startDate && toUTCDate(startDate) === toUTCDateDay(day) || endDate && toUTCDate(endDate) === toUTCDateDay(day);
  };

  var inRange = function inRange(day) {
    return startDate && toUTCDate(startDate) <= toUTCDateDay(day) && endDate && toUTCDate(endDate) >= toUTCDateDay(day);
  };

  var isDisabled = function isDisabled(day) {
    var local = new Date(Date.UTC(year, month, day));
    var now = new Date();
    var nowUTC = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    var pastDatesDisabled = disablePastDates && local.getTime() < nowUTC;
    var futureDateDisabled = disableFutureDates && local.getTime() > nowUTC;
    return pastDatesDisabled || futureDateDisabled;
  };

  var _onClick = function onClick(day) {
    var selectedDate = new Date(Date.UTC(year, month, day));
    if (isDisabled(day) || startDate && selectedDate.getTime() === toUTCDate(startDate)) return;

    if (type === 'single') {
      onSelectSingle(selectedDate);
    } else if (type === 'range') {
      onSelectRange(selectedDate);
    }
  };

  var getFirstWeek = function getFirstWeek() {
    var day = getDayOfWeek(1);

    var week = _.range(1, 7 - day + 1);

    var lastDayBefore = getDaysInMonthBefore();
    var daysBefore = [];

    for (var i = lastDayBefore - (day - 1); i <= lastDayBefore; i += 1) {
      daysBefore.push(i);
    }

    week = _.concat(daysBefore, week);
    return week.map(function (val) {
      return /*#__PURE__*/React.createElement(DayField, {
        key: val,
        disabled: val > 7 || isDisabled(val),
        selected: isEqual(val),
        onClick: function onClick() {
          return val <= 7 && _onClick(val);
        },
        inRange: type === 'range' && val <= 7 && inRange(val),
        aux: {
          val: val,
          startDate: startDate,
          endDate: endDate,
          year: year,
          month: month
        }
      }, /*#__PURE__*/React.createElement(Text.Small, null, val));
    });
  };

  var getMiddleWeeks = function getMiddleWeeks() {
    var day = getDayOfWeek(1);
    var firstDay = 7 - day + 1;
    var weeks = [];

    while (firstDay + 7 <= getDaysInMonth()) {
      weeks.push(_.range(firstDay, firstDay + 7));
      firstDay += 7;
    }

    return weeks.map(function (week, i) {
      var days = week.map(function (val) {
        return /*#__PURE__*/React.createElement(DayField, {
          selected: isEqual(val),
          onClick: function onClick() {
            return _onClick(val);
          },
          inRange: type === 'range' && inRange(val),
          key: val,
          disabled: isDisabled(val),
          aux: {
            val: val,
            startDate: startDate,
            endDate: endDate,
            year: year,
            month: month
          }
        }, /*#__PURE__*/React.createElement(Text.Small, null, val));
      });
      /* eslint-disable-next-line react/no-array-index-key */

      return /*#__PURE__*/React.createElement(Row, {
        key: i
      }, days);
    });
  };

  var getLastWeek = function getLastWeek() {
    var lastDay = getDaysInMonth();
    var day = getDayOfWeek(lastDay);

    var week = _.range(lastDay - day, lastDay + 1);

    week = _.concat(week, _.range(1, 7 - day));
    return week.map(function (val) {
      return /*#__PURE__*/React.createElement(DayField, {
        key: val,
        disabled: val < 7 || isDisabled(val),
        selected: isEqual(val),
        onClick: function onClick() {
          return val > 7 && _onClick(val);
        },
        inRange: type === 'range' && val > 7 && inRange(val),
        aux: {
          val: val,
          startDate: startDate,
          endDate: endDate,
          year: year,
          month: month
        }
      }, /*#__PURE__*/React.createElement(Text.Small, null, val));
    });
  };

  var getDays = function getDays() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, getFirstWeek()), getMiddleWeeks(), /*#__PURE__*/React.createElement(Row, null, getLastWeek()));
  };

  var prior = function prior() {
    var local = month - 1;

    if (local < 0) {
      local = 11;
      setYear(year - 1);
    }

    setMonth(local);
  };

  var next = function next() {
    var local = month + 1;

    if (local > 11) {
      local = 0;
      setYear(year + 1);
    }

    setMonth(local);
  };

  return /*#__PURE__*/React.createElement(CalendarWrapper, null, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    m: "xxsmall",
    mb: "zero",
    pb: "small"
  }, /*#__PURE__*/React.createElement(Icon, {
    style: {
      cursor: 'pointer'
    },
    as: ChevronLeft,
    width: "large",
    height: "large",
    onClick: prior,
    fill: "primary",
    "data-testid": "previous-month-arrow"
  }), /*#__PURE__*/React.createElement(Text, {
    style: {
      alignSelf: 'center'
    }
  }, new Intl.DateTimeFormat('en-US', {
    month: 'long',
    year: 'numeric'
  }).format(new Date(year, month, 1, 0, 0, 0))), /*#__PURE__*/React.createElement(Icon, {
    style: {
      cursor: 'pointer'
    },
    as: ChevronRight,
    width: "large",
    height: "large",
    onClick: next,
    fill: "primary",
    "data-testid": "next-month-arrow"
  })), /*#__PURE__*/React.createElement(DaysWrapper, null, /*#__PURE__*/React.createElement(Day, null, "S"), /*#__PURE__*/React.createElement(Day, null, "M"), /*#__PURE__*/React.createElement(Day, null, "T"), /*#__PURE__*/React.createElement(Day, null, "W"), /*#__PURE__*/React.createElement(Day, null, "T"), /*#__PURE__*/React.createElement(Day, null, "F"), /*#__PURE__*/React.createElement(Day, null, "S")), /*#__PURE__*/React.createElement(Box, null, getDays()));
}

Calendar.propTypes = {
  type: oneOf(['single', 'range']).isRequired,
  startDate: instanceOf(Date),
  endDate: instanceOf(Date),
  onSelectSingle: func,
  onSelectRange: func,
  disablePastDates: bool,
  disableFutureDates: bool
};
Calendar.defaultProps = {
  startDate: undefined,
  endDate: undefined,
  onSelectSingle: null,
  onSelectRange: null,
  disablePastDates: false,
  disableFutureDates: false
};
export default Calendar;